import React, { Component } from 'react';

import axios from '../../axios';
import { eraseCookie } from '../../function';
import Loader from '../../component/loader/loader';
export default class Logout extends Component {
    componentDidMount = () => {
        eraseCookie("isTAC");
		eraseCookie("TAC_URL");	
        eraseCookie('threatcop');
        eraseCookie('logo');
        eraseCookie('userType');
        eraseCookie('username');
        eraseCookie('userAgent');
        eraseCookie('firstname');
        eraseCookie('billingType');
        eraseCookie('isDashboard');
        eraseCookie('accessLevel');
        eraseCookie('isTAconnected');
        eraseCookie('isNewClient');
        eraseCookie('isTASyncing');
        eraseCookie('integrationModalOpened');
        eraseCookie('tacEnabled');
        eraseCookie('isThreatcopUnleashedClosed');

        localStorage['email'] = '';
        localStorage['lastname'] = '';
        localStorage['firstname'] = '';
        localStorage["sessionId"] = "";
        
        axios.get('/api/auth/logout', {})
        .then(r => {
            window.location = '/login';
        })
        .catch(() => {
            window.location = '/login';
        })

    }
    render(){ 
        return (
            <Loader></Loader>
        )
    }
}